// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonBase_button__SOIgU","fullWidth":"ButtonBase_fullWidth__g0ppN"};